<template>

  <div @click="copyMethodsWrapper()">
    <m-icon :icon="iconName" class="cursor-pointer mx-2 copy-1-icon"/>
    <div class="copy-1-text-wrapper">
      <slot></slot>
    </div>
  </div>

</template>

<script>
import mIcon from '../../Icons/Icon.vue'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "Copy1",
  components: {mIcon},
  props: {
    itemId: {
      default: null
    },
    itemType: {
      options: ['product', 'course', 'post', 'page', 'lesson', 'text'],
      default: 'product'
    },
    iconName: {
      default: 'files'
    },
  },
  data() {
    return {
      typeAttributes: {
        product: {
          route: {name: 'EditProduct', params: {slug: ''}},
          type: 'product',
        },
        course: {
          route: {name: 'EditCourse', params: {slug: ''}},
          type: 'course',
        },
        post: {
          route: {name: 'UpdateContent', params: {slug: ''}},
          type: 'content',
        },
        page: {
          route: {name: 'UpdateContent', params: {slug: ''}},
          type: 'content',
        },
        lesson: {
          route: {name: 'UpdateLessons', params: {slug: ''}},
          type: 'content',
        },
      }
    }
  },
  methods: {
    duplicateItem() {
      const selectedType = this.typeAttributes[this.itemType]
      if (confirm(this.$t('tools.copy.copy_alert'))) {
        const form = {
          item_type: selectedType.type,
          item_id: this.itemId
        }

        this.$store.dispatch('Content/duplicateItem', form)
            .then((res) => {
              const data = res.data.data
              let route = selectedType.route;
              if (this.itemType == 'product') {
                route.params.slug = data.raw_link
              } else {
                route.params.slug = data.slug
              }

              this.$router.push(route)

            })
            .catch((error) => {
              console.log(error);
            });
      }

    },
    copyMethodsWrapper() {
      if (this.itemType === 'text') {
        this.copyItemIdToClipBoard();
        return true
      }
      this.duplicateItem();
    },
    copyItemIdToClipBoard() {
      navigator.clipboard.writeText(this.itemId);
      toast(this.$t('tools.copy.copy_success_message'), this.$t('tools.copy.copy_success_message'), 'success')
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>